/**
 * Interactivity associated with author modules, such as expand/collapse behavior for their "about" section.
 */
export const author = () => {
  // Skip expand/collapse behavior if in edit mode
  if (document.documentElement.dataset.editMode === "true") {
    return;
  }

  const collapsedCssClass = "h-0";

  const aboutSections = document.querySelectorAll(
    "[data-author-about]"
  ) as NodeListOf<HTMLElement>;

  const animationDuration = 200;

  const expand = (
    sectionContent: HTMLElement,
    contentHeight: number,
    openButton: HTMLElement,
    closeButton: HTMLElement | null
  ) => {
    sectionContent.classList.remove(collapsedCssClass);
    sectionContent.style.height = `${contentHeight}px`;

    openButton.classList.add("opacity-0", "-z-10");

    // HACK Allow time for animation to complete before switching to auto-height
    setTimeout(() => {
      sectionContent.style.height = "auto";
      closeButton?.classList.remove("opacity-0");
    }, animationDuration);
  };

  const collapse = (
    sectionContent: HTMLElement,
    contentHeight: number,
    openButton: HTMLElement,
    closeButton: HTMLElement | null
  ) => {
    sectionContent.style.height = `${contentHeight}px`;
    closeButton?.classList.add("opacity-0");

    // HACK Avoid instant collapse
    setTimeout(() => {
      sectionContent.style.height = "0px";
      sectionContent.classList.add(collapsedCssClass);
    }, 0);

    setTimeout(() => {
      openButton.classList.remove("opacity-0", "-z-10");
    }, animationDuration);
  };

  aboutSections.forEach(section => {
    const openButton = section.querySelector(
      "[data-author-about-open]"
    ) as HTMLElement | null;
    const closeButton = section.querySelector(
      "[data-author-about-close]"
    ) as HTMLElement | null;

    if (!openButton) {
      console.error("Unable to find open button for author about section");

      return;
    }

    const toggle = (targetState: boolean) => {
      const sectionContent = section.querySelector(
        "[data-author-about-content]"
      ) as HTMLElement;
      const sectionContentInnerWrapper = sectionContent.querySelector(
        "[data-author-about-content-wrapper]"
      ) as HTMLElement | null;

      if (!sectionContentInnerWrapper) {
        console.error(
          "Unable to find inner wrapper for author about section, which is required to determine the target height in order to expand/collapse smoothly"
        );

        return;
      }

      const contentHeight = sectionContentInnerWrapper.getBoundingClientRect().height;

      targetState
        ? expand(sectionContent, contentHeight, openButton, closeButton)
        : collapse(sectionContent, contentHeight, openButton, closeButton);
    };

    openButton.onclick = () => toggle(true);

    if (closeButton) {
      closeButton.onclick = () => toggle(false);
    }

    // Ensure links are still clickable without triggering expand/collapse
    section.querySelectorAll("a").forEach(a => {
      a.onclick = event => {
        event.stopPropagation();
      };
    });
  });
};
